"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _dates = require("../../../../utilities/dates");
var _DateTimePickers = _interopRequireDefault(require("../../DateTimePickers.styles"));
require("react-datepicker/dist/react-datepicker.css");
var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));
var _he = _interopRequireDefault(require("date-fns/locale/he"));
var _ar = _interopRequireDefault(require("date-fns/locale/ar"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(0, _reactDatepicker.registerLocale)('en', _enUS.default);
(0, _reactDatepicker.registerLocale)('he', _he.default);
(0, _reactDatepicker.registerLocale)('ar', _ar.default);
var InlineView = function InlineView(props) {
  var id = props.id,
    minDate = props.minDate,
    maxDate = props.maxDate,
    isDisabled = props.isDisabled,
    startDate = props.startDate,
    endDate = props.endDate,
    _props$attachedTo = props.attachedTo,
    attachedTo = _props$attachedTo === void 0 ? 'StartEndDates' : _props$attachedTo,
    onChange = props.onChange;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext.language;
  var styles = (0, _DateTimePickers.default)(props);
  var createRangeDate = function createRangeDate(date1, date2) {
    var start;
    var end;
    if (date1 < date2) {
      start = (0, _dates.restrictToMinDate)(date1, minDate !== null && minDate !== void 0 ? minDate : new Date(0, 0, 0));
      end = (0, _dates.restrictToMaxDate)(date2, maxDate !== null && maxDate !== void 0 ? maxDate : new Date(3000, 0, 31));
    } else {
      start = (0, _dates.restrictToMinDate)(date2, minDate !== null && minDate !== void 0 ? minDate : new Date(0, 0, 0));
      end = (0, _dates.restrictToMaxDate)(date1, maxDate !== null && maxDate !== void 0 ? maxDate : new Date(3000, 0, 31));
    }
    return {
      start: start,
      end: end
    };
  };
  var handleDateChange = function handleDateChange(dates) {
    if (isDisabled) {
      return;
    }
    if (dates) {
      var start = startDate;
      var end = endDate;
      if (Array.isArray(dates)) {
        if (start && end) {
          start = undefined;
          end = undefined;
        }
        if (dates[0] && dates[1]) {
          var range = createRangeDate(dates[0], dates[1]);
          start = range.start;
          end = range.end;
        } else if (dates[0]) {
          if (!start) {
            start = (0, _dates.restrictToMinDate)(dates[0], minDate !== null && minDate !== void 0 ? minDate : new Date(0, 0, 0));
          } else {
            var _range = createRangeDate(start, dates[0]);
            start = _range.start;
            end = _range.end;
          }
        }
      } else if (attachedTo === 'StartDate') {
        start = (0, _dates.restrictToMinDate)(dates, minDate !== null && minDate !== void 0 ? minDate : new Date(0, 0, 0));
        if (end && start && end.getTime() < start.getTime()) {
          end = undefined; //we want to change only the start date;
        }
      } else if (attachedTo === 'EndDate') {
        end = (0, _dates.restrictToMaxDate)(dates, maxDate !== null && maxDate !== void 0 ? maxDate : new Date(3000, 0, 31));
        if (end && start && end.getTime() < start.getTime()) {
          start = undefined; //we want to change only the end date;
        }
      }

      onChange(start, end);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-DatePicker'],
    "data-testid": id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDatepicker.default, {
      locale: language,
      minDate: minDate,
      maxDate: maxDate,
      selected: attachedTo === 'EndDate' ? endDate : startDate,
      startDate: startDate,
      endDate: endDate,
      selectsRange: attachedTo === 'StartEndDates',
      inline: true,
      disabled: isDisabled,
      onChange: handleDateChange,
      readOnly: isDisabled,
      dayClassName: styles['cc-DatePicker__day']
    })
  });
};
exports.InlineView = InlineView;